import { THEME_MODES } from '@didaskill/domain/configurations/constants';
import { LOCALES } from '@didaskill/ui/intl';

export const LOCALE_OPTIONS = [
  { value: LOCALES.FR, label: '🇫🇷 Français' },
  { value: LOCALES.EN, label: '🇺🇸 English' },
];

export const THEME_MODE_OPTIONS = [
  { value: THEME_MODES.DEFAULT, label: '☀️ Light' },
  { value: THEME_MODES.DARK, label: '🌗 Dark' },
];
